// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body textarea {
  height: auto !important;
  width: 100% !important;
  min-height: 80px;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  padding: 8px !important;
  resize: vertical;
}
textarea[name="resNote"] {
  min-height: 60px !important;
}
textarea[name="noteToAdd"] {
  min-height: 60px !important;
}
textarea[name="dispoNote"] {
  min-height: 100px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dispute-tracker/dispute-modal/dispute-modal.component.less"],"names":[],"mappings":"AAGA;EAEI,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iCAAA;EACA,6BAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;AAQA;EACE,2BAAA;AANF;AASA;EACE,2BAAA;AAPF;AAUA;EACE,4BAAA;AARF","sourcesContent":["@import (reference) url('../../../assets/ngb-modals.less');\n\n// Fix textarea styling conflicts with grid styles\n.modal-body {\n  textarea {\n    height: auto !important; \n    width: 100% !important;  \n    min-height: 80px;       \n    border: 1px solid #ccc !important; \n    border-radius: 4px !important;     \n    padding: 8px !important;           \n    resize: vertical;                  \n  }\n}\n\n\ntextarea[name=\"resNote\"] {\n  min-height: 60px !important;\n}\n\ntextarea[name=\"noteToAdd\"] {\n  min-height: 60px !important;\n}\n\ntextarea[name=\"dispoNote\"] {\n  min-height: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
